module.exports = __webpack_public_path__ + "h5/img/boutique_title_more.84525bc7.png";